import { useCommunicationDetailsPage } from '../context/CommunicationDetailsPageContext';

const CommunicationHeader = () => {
  const { data, actions } = useCommunicationDetailsPage();

  return (
    <div className="nk-ibx-reply-head d-flex align-items-center">
      <div>
        <h4 className="title m-0">{data.communication?.subject}</h4>
      </div>
      <ul className="d-flex ml-auto">
        <li className="mr-n1">
          <div className="asterisk">
            <span
              className="btn btn-trigger btn-icon btn-tooltip"
              onClick={actions.handleOpenCertification}
            >
              <em className="icon ni ni-shield-check" />
            </span>
          </div>
        </li>
        {/* <li className="d-none d-sm-block">
          <ReactToPrint
            trigger={() => (
              <span className="btn btn-icon btn-trigger btn-tooltip">
                <em className="icon ni ni-printer" />
              </span>
            )}
            content={() => printRef.current as any}
            documentTitle={`${actualSociety?.name} - ${
              communication?.subject
            } ${format(new Date(), 'dd-MM-yyyy')}`}
          />
        </li> */}
        {!data.isReadOnly && (
          <li className="mr-n1">
            <div className="asterisk">
              <span
                className="btn btn-trigger btn-icon btn-tooltip"
                onClick={actions.handleToggleFavorite}
              >
                {data.communication?.isFavorite ? (
                  <em className="asterisk-off icon ni ni-star-fill text-primary" />
                ) : (
                  <em className="asterisk-off icon ni ni-star" />
                )}
              </span>
            </div>
          </li>
        )}
      </ul>
    </div>
  );
};

export default CommunicationHeader;
